export const MCP_AGENT_CODRIVER = 'codriver';
export const MCP_AGENT_CHATGPT = 'chatgpt';
export const MCP_AGENT_CLAUDE = 'claude';
